<template>
  <div class="card ">
    <a-row :gutter="10">
      <a-col :span="5" v-for="(item,index) in countData" :key="index">
        <div class="col-item" :style="{backgroundImage:'url('+item.img+')'}">
          <div class="card-title">
            {{ item.name }}
          </div>
          <div class="card-value">
            {{ item.value }}
          </div>
        </div>
      </a-col>
    </a-row>
    <a-form class="ant-advanced-search-form" ref="formData" :model="formData" v-if="isCondition">
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="商品名称:">
            <a-input v-model="formData.title" placeholder="请输入" allow-clear>
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="商品ID:" prop="gid">
            <a-input v-model="formData.gid" placeholder="请输入" allow-clear>
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="下单手机号:" prop="phone">
            <a-input v-model="formData.phone" placeholder="请输入" allow-clear>
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="平台:">
            <a-select
                allowClear
                v-model="formData.pvd"
            >
              <a-select-option :value="item.value" v-for="(item) in records.pvd_list" :key="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="创建时间:">
            <a-range-picker v-model="formData.dateTime" ref="rangePicker" @change="dateChange1" format="YYYY-MM-DD"/>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="">
            <a-button type="primary" @click="onSubmit">
              提交
            </a-button>
            <a-button style="margin-left: 10px;" @click="onReset">
              重置
            </a-button>
          </a-form-item>
        </a-col>
        <a-col :span="6">
        </a-col>
      </a-row>
    </a-form>
    <div class="operate-area">
      <div class="left-btn">
        <a-button icon="redo" type="primary" style="margin-left: 5px" @click="_fetchData"></a-button>
      </div>
      <div>
        <a-button type="primary" icon="search" @click="onCondition"/>
      </div>
    </div>
    <div class="table-border">
      <a-table :data-source="records.list" bordered class="table" rowKey="id" :pagination="pagination" @change="onPaginationChange" :scroll="{x: 500, y: 500}" :loading="loadingPage">
        <a-table-column title="商品ID" width="94px" align="center">
          <template slot-scope="scope">
            {{ scope.gid }}
          </template>
        </a-table-column>

        <a-table-column title="商品名称" width="140px" align="center">
          <template slot-scope="scope">
            <div style="" class="custom-title">
              {{ scope.title }}
            </div>
          </template>
        </a-table-column>
        <a-table-column title="平台" width="60px" align="center">
          <template slot-scope="scope">
            {{ scope.pvd_str }}
          </template>
        </a-table-column>
        <a-table-column title="下单手机号" width="90px" align="center">
          <template slot-scope="scope">
            {{ scope.phone }}
          </template>
        </a-table-column>
        <a-table-column title="订单号" width="94px" align="center">
          <template slot-scope="scope">
            {{ scope.oid ? scope.oid : '-' }}
          </template>
        </a-table-column>
        <a-table-column title="付款金额" width="78px" align="center">
          <template slot-scope="scope">
            {{ scope.price ? `¥${scope.price}` : '-' }}
          </template>
        </a-table-column>
        <a-table-column title="补贴金额" width="78px" align="center">
          <template slot-scope="scope">
            {{ scope.subsidy_price ? `¥${scope.subsidy_price}` : '-' }}
          </template>
        </a-table-column>
        <a-table-column title="服务费金额" width="78px" align="center">
          <template slot-scope="scope">
            {{ scope.fee ? `¥${scope.fee}` : '-' }}
          </template>
        </a-table-column>
        <a-table-column title="扣除积分" width="78px" align="center">
          <template slot-scope="scope">
            <span style="color: red;"> {{ scope.deduct_price }}</span>
          </template>
        </a-table-column>
        <a-table-column title="结算状态" width="65px" align="center">
          <template slot-scope="scope">
            <span v-if="scope.settle_state=='待结算'" style="color: #E01616">
              {{ scope.settle_state }}
            </span>
            <span v-else-if="scope.settle_state=='已结算'" style="color: #0E9205">
              {{ scope.settle_state }}
            </span>
            <span v-else>
              {{ scope.settle_state }}
            </span>
          </template>
        </a-table-column>
        <a-table-column title="订单状态" width="80px" align="center">
          <template slot-scope="scope">
            {{ scope.state_str }}
          </template>
        </a-table-column>
        <a-table-column title="积分扣除时间" width="90px" align="center">
          <template slot-scope="scope">
            {{ scope.deduct_time }}
          </template>
        </a-table-column>
        <a-table-column title="创建时间" width="90px" align="center">
          <template slot-scope="scope">
            {{ scope.time }}
          </template>
        </a-table-column>
        <a-table-column title="操作" align="center" width="95px">
          <template slot-scope="scope">
            <a-button :scope="scope" type="primary" @click="onDetailed(scope)">
              查看详情
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <DetailedDialog ref="detailedDialog"/>
  </div>
</template>

<script>
import {fetchOrderData, fetchOrderList} from "@/api/merchant-registration";
import DetailedDialog from './components/detailed-dialog'

export default {
  components: {DetailedDialog},
  data() {
    return {
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      loadingPage: true,
      isCondition: false,
      formData: {
        dateTime: [],
        "pvd": "",
        "nickname": "",
        "phone": "",
        "title": "",
        "gid": "",
        "start_time": "",
        "end_time": "",
      },
      records: {
        state_list: [],
        pvd_list: []
      },
      countData: []
    }
  },
  mounted() {
    this._fetchData()
    this._fetchGoodData()
  },
  methods: {
    onDetailed(row) {
      this.$refs.detailedDialog.show(row)
    },
    dateChange1(_, dateString) {
      this.formData.start_time = dateString[0]
      this.formData.end_time = dateString[1]
    },
    onReset() {
      this.formData.title = ''
      this.formData.nickname = ''
      this.formData.phone = ''
      this.formData.gid = ''
      this.formData.pvd = ''
      this.formData.start_time = ''
      this.formData.end_time = ''
      this.formData.dateTime = null
    },
    onSubmit() {
      this.loadingPage = true
      this.pagination.current = 1
      this._fetchGoodData()
      this._fetchData()
    },
    _fetchData(isRefresh = false) {
      let params = JSON.parse(JSON.stringify(this.formData))
      params.p = this.pagination.current + ''
      params.size = this.pagination.pageSize + ''
      delete params.dateTime
      fetchOrderList(params).then(resp => {
        if (isRefresh) {
          this.$message.success('刷新成功')
        }
        resp.list = resp.list ? resp.list : []
        this.pagination.total=resp.total
        this.loadingPage = false
        this.records = resp
      })

    },
    _fetchGoodData() {
      let params = JSON.parse(JSON.stringify(this.formData))
      delete params.dateTime
      fetchOrderData(params).then(resp => {
        resp = resp ? resp : []
        if (resp.length > 0) {
          resp[0].img = require('../../../assets/images/store-registration/count-img1.png')
          resp[1].img = require('../../../assets/images/store-registration/count-img2.png')
          resp[2].img = require('../../../assets/images/store-registration/count-img3.png')
        }
        resp.map(item => {
          item.value = item.value ? item.value : 0
        })
        this.countData = resp
      })
    },
    onCondition() {
      this.isCondition = !this.isCondition
    },
    onPaginationChange(pagination) {
      this.pagination = pagination
      this._fetchData()
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  background: #FFFFFF;
  box-shadow: 0px 0px 28px 0px rgba(217, 217, 217, 0.19);
  border-radius: 13px;
  padding: 24px;
}

::v-deep .ant-table-column-title {
  font-size: 14px;
}

::v-deep .ant-table-row-cell-break-word {
  font-size: 14px;
}

::v-deep .ant-table-thead > tr > th {
  padding: 11px 8px;
}

.value-price {
  color: #666;
}

.custom-title {
  word-break: break-all;
}

::v-deep .ant-col-5 {
  width: 20%;
}

.ant-advanced-search-form {
  margin-top: 60px;
  padding-left: 40px;
  padding-right: 40px;

  .ant-form-item {
    display: flex;
  }

  ::v-deep .ant-form-item-label label {
    font-size: 14px;
    font-weight: 400;
    color: #606060;
  }

  ::v-deep .ant-form-item-control-wrapper {
    flex: 1;
  }

  ::v-deep .ant-form {
    max-width: none;
  }
}

.operate-area {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;

  .success-btn {
    background: #67c23a;
    color: #fff;
    border-color: #67c23a;
  }
}

.custom-btn {
  background: #F77F00 !important;
  border-color: #F77F00 !important;
}


.col-item {
  border-radius: 12px;
  padding: 21px 20px;
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .card-title {
    font-size: 17px;
    font-weight: 400;
    color: #FFFFFF;
  }

  .card-value {
    font-size: 35px;
    font-family: ' DIN, DIN';
    font-weight: 500;
    color: #FFFFFF;
  }
}

.table-border {
  position: relative;
  height: 600px;
}

.table {
  margin-top: 20px;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

</style>
